import React from "react";
import { Helmet } from "react-helmet";

import { faqBazaarSellingTips } from "@/mk2/apps/faq/urls";
import { BackBtn } from "@/mk2/components/BackBtn";
import { BtnLayout, BtnType } from "@/mk2/components/Btn";
import { Img } from "@/mk2/components/Img";
import {
    CTA_RETURN_BACK,
    _404_MY_BAZAAR_LAST_PRODUCT_NOT_FOUND,
} from "@/mk/autogenerated/translation";
import assetUrl from "@/mk/common/assetUrl";

import styles from "./MyBazaarLastProductNotFound.mscss";

interface OwnProps {}

export class MyBazaarLastProductNotFound extends React.Component<OwnProps> {
    public render() {
        const title = _404_MY_BAZAAR_LAST_PRODUCT_NOT_FOUND;
        return (
            <div className={styles.NotFoundError}>
                <div className={styles.NotFoundError}>
                    <Helmet>
                        <title>{title}</title>
                        <meta property="og:title" content={title} />
                    </Helmet>
                    <div className={styles.NotFoundError__icon}>
                        <Img
                            className={styles.NotFoundError__icon__image}
                            src={assetUrl + "img/miky/shrug-miky@2x.png"}
                            width={268}
                            height={271}
                        />
                    </div>
                    <div className={styles.NotFoundError__message}>{title}</div>
                    <div className={styles.NotFoundError__button}>
                        <BackBtn
                            label={CTA_RETURN_BACK}
                            layout={BtnLayout.IconLabelCount}
                            link={faqBazaarSellingTips}
                            type={BtnType.Blue}
                        />
                    </div>
                </div>
            </div>
        );
    }
}
